<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  جزئیات مبادله
                  
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div class="text-center">
                  <button class="ar-btn size-xl primary round ">
                    <template v-if="exchange.type == 'buy'">خرید</template> 
                    <template v-if="exchange.type == 'sell'">فروش</template> 
                    <template v-if="exchange.type == 'deposit'">واریز</template> 
                    <template v-if="exchange.type == 'withdraw'">برداشت</template> 
                    <template v-if="exchange.type == 'convert'">تبدیل</template> 
                  </button>
                </div>
                <div v-if="exchange.status == 2" class="text-danger flex-type-1">
                    <div>علت رد:</div>
                    <b>{{exchange.reject_reason}}</b>
                </div>
                <div class="flex-type-1">
                    <div></div>
                    <b>{{exchange.registered_at}}</b>
                    <div></div>
                </div>

                <div class="main-details" v-if="exchange.type == 'deposit'">
                    <template v-if="exchange.paid_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مبلغ واریزی:</div>
                            <bdi>{{ formatPrice(exchange.paid_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else-if="exchange.paid_currency == 'USDT'">
                        <div class="flex-type-1">
                            <div>مقدار واریزی:</div>
                            <bdi>{{ exchange.paid_amount }} تتر</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار واریزی:</div>
                            <bdi>{{ exchange.paid_amount }} {{exchange.paid_currency}}</bdi>
                        </div>
                    </template>
                </div>

                <div class="main-details" v-if="exchange.type == 'withdraw'">
                    <template v-if="exchange.received_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مبلغ برداشتی:</div>
                            <bdi>{{ formatPrice(exchange.received_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else-if="exchange.received_currency == 'USDT'">
                        <div class="flex-type-1">
                            <div>مقدار برداشتی:</div>
                            <bdi>{{ exchange.received_amount }} تتر</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار برداشتی:</div>
                            <bdi>{{ exchange.received_amount }} {{exchange.received_currency}}</bdi>
                        </div>
                    </template>
                </div>

                <div class="main-details" v-if="exchange.type == 'buy'">
                    <template v-if="exchange.paid_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مبلغ واریزی:</div>
                            <bdi>{{ formatPrice(exchange.paid_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار واریزی:</div>
                            <bdi>{{ exchange.paid_amount }} {{exchange.paid_currency}}</bdi>
                        </div>
                    </template>

                    <div v-if="exchange.criteria_rate" class="flex-type-1">
                        <div>نرخ تتر:</div>
                        <bdi>{{ exchange.criteria_rate }} تومان</bdi>
                    </div>

                    <template v-if="exchange.received_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مبلغ دریافتی:</div>
                            <bdi>{{ formatPrice(exchange.received_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>میزان دریافتی:</div>
                            <bdi>{{ exchange.received_amount }} {{exchange.received_currency}}</bdi>
                        </div>
                    </template>
                </div>

                <div class="main-details" v-if="exchange.type == 'sell'">
                    <template v-if="exchange.paid_currency == 'USDT'">
                        <div class="flex-type-1">
                            <div>میزان واریزی:</div>
                            <bdi>{{ exchange.paid_amount }} تتر</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار واریزی:</div>
                            <bdi>{{ exchange.paid_amount }} {{exchange.paid_currency}}</bdi>
                        </div>
                    </template>

                    
                    <div v-if="exchange.criteria_rate" class="flex-type-1">
                        <div>نرخ تتر:</div>
                        <bdi>{{ exchange.criteria_rate }} تومان</bdi>
                    </div>

                    <template v-if="exchange.paid_currency !== 'USDT'">
                        <div class="flex-type-1">
                            <div>قیمت ثبت شده ارز پرداختی:</div>
                            <bdi>{{ exchange.paid_currency_price }}</bdi>
                        </div>
                    </template>

                    <template v-if="exchange.received_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مبلغ دریافتی:</div>
                            <bdi>{{ formatPrice(exchange.received_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>میزان دریافتی:</div>
                            <bdi>{{ exchange.received_amount }} {{exchange.received_currency}}</bdi>
                        </div>
                    </template>
                </div>

                <div class="main-details" v-if="exchange.type == 'convert'">
                    <template v-if="exchange.paid_currency == 'IRR'">
                      <div class="flex-type-1">
                        <div>مقدار تبدیل :</div>
                        <bdi>{{ formatPrice(exchange.paid_amount) }} تومان</bdi>
                      </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار تبدیل:</div>
                            <bdi>{{ exchange.paid_amount }} {{exchange.paid_currency}}</bdi>
                        </div>
                    </template>

                    <div v-if="exchange.criteria_rate" class="flex-type-1">
                        <div>نرخ تتر:</div>
                        <bdi>{{ exchange.criteria_rate }} تومان</bdi>
                    </div>

                    <template v-if="exchange.received_currency == 'IRR'">
                        <div class="flex-type-1">
                            <div>مقدار محاسبه شده:</div>
                            <bdi>{{ formatPrice(exchange.received_amount) }} تومان</bdi>
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex-type-1">
                            <div>مقدار محاسبه شده:</div>
                            <bdi>{{ exchange.received_amount }} {{exchange.received_currency}}</bdi>
                        </div>
                    </template>
                </div>

                <div v-if="exchange.user_wallet" class="flex-type-1 px-2">
                    <div>
                      <template v-if="exchange.type == 'buy'">
                        ولت مقصد
                      </template>
                      <template v-else-if="exchange.type == 'sell'">
                        ولت مبدا
                      </template>
                      <template v-else>
                        ولت
                      </template>
                    </div>
                    <bdi style="word-break: break-word;">{{ exchange.user_wallet.address }}</bdi>
                </div>
                <div v-if="exchange.user_wallet" class="flex-type-1 px-2">
                    <div>شبکه</div>
                    <bdi style="word-break: break-word;">{{ exchange.user_wallet.network }}</bdi>
                </div>

                <div v-if="exchange.user_bank_account" class="flex-type-1 px-2">
                    <div>
                      <template v-if="exchange.type == 'buy'">
                        شماره کارت بانک مبدا:
                      </template>
                      <template v-else-if="exchange.type == 'sell'">
                        شماره کارت بانک مقصد:
                      </template>
                      <template v-else>
                        شماره کارت بانکی
                      </template>
                    </div>
                    <bdi style="word-break: break-word;">{{ exchange.user_bank_account.card_number }}</bdi>
                </div>
                <div v-if="exchange.user_bank_account" class="flex-type-1 px-2">
                    <div>
                      <template v-if="exchange.type == 'buy'">
                        شماره شبا بانک مبدا:
                      </template>
                      <template v-else-if="exchange.type == 'sell'">
                        شماره شبا بانک مقصد:
                      </template>
                      <template v-else>
                        شماره شبا بانکی
                      </template>
                    </div>
                    <bdi style="word-break: break-word;">{{ exchange.user_bank_account.shaba_number }}</bdi>
                </div>

                <div v-if="exchange.txid" class="flex-type-1 px-2">
                    <div>هش تراکنش:</div>
                    <bdi style="word-break: break-word;">{{ exchange.txid }}</bdi>
                </div>

                <div class="flex-type-1">
                  <div></div>
                  <b>
                    <span v-if="exchange.status == 0" class="ar-btn size-xl warning" style="padding : 1rem 3rem"> درحال بررسی</span>
                    <span v-if="exchange.status == 1" class="ar-btn size-xl success" style="padding : 1rem 3rem"> تایید شده</span>
                    <span v-if="exchange.status == 2" class="ar-btn size-xl danger" style="padding : 1rem 3rem"> رد شده</span>
                    <template v-if="exchange.type == 'sell'">
                      <span v-if="exchange.status == 3 || exchange.status == 4" class="ar-btn size-xl primary" style="padding : 1rem 3rem"> در حال واریز</span>
                    </template>
                    <template v-else>
                      <span v-if="exchange.status == 3 || exchange.status == 4" class="ar-btn size-xl primary" style="padding : 1rem 3rem"> در حال ارسال</span>
                    </template>
                  </b>
                  <div></div>
                </div>

                <div>
                  <i class="mdi mdi-circle"></i>
                  تراکنش شما بدون کارمزد انجام شده و ارزینه در کارمزد شبکه تصرفی ندارد.
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import Modal from '../../components/Modal.vue'
export default {
  name: 'ExchangeDetails',
  components:{
    Sidebar, Header, Modal,
  },
  data : () => ({
    exchange:{},
    errors:{},
    loading : false,
  }),
  methods:{
    getExchange(id){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`exchangeDetails`,{id},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.exchange = res.data.data
        this.activeLoading(false)
      })
      .catch( () => {
        this.$router.push({name:'Records'});
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.checkConfirmed()

    if(this.$route.params.id !== ''){
      this.getExchange(this.$route.params.id)
    }else{
      this.$router.push({name:'Records'});
    }

  }
}
</script>
<style>
.flex-type-1{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
}
.main-details{
  background:#E2DEDE;padding: 1px .5rem;border-radius:.5rem
}
</style>